import BuildingsGrid from './buildings-grid';

export default function BuildingsPage() {
  return <BuildingsGrid />;
}
